// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.panel-body {
	/* This fixes a CSS issue where, if the first child element of a div has margin-top, the margin is applied to all parents and a scrollbar appears for divs with hight 100% */
	padding-top: 0.1px;
}

`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
